import React from "react";
import { useField } from "formik";
import { TextField } from "@mui/material";

function FormInput({
  label,
  signal,
  showError = true,
  type = "text",
  placeholder = "",
  ...otherProps
}) {
  const [field, meta] = useField(otherProps);

  const handleChange = (event) => {
    field.onChange(event);
  };

  return (
    <TextField
      fullWidth
      // autoComplete="username"
      size="small"
      type={type}
      label={label}
      {...field}
      placeholder={placeholder}
      onChange={handleChange}
      value={field.value}
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
    />
  );
}

export default FormInput;
